import { Col, Container, Row } from "react-bootstrap";
import { BackLink, CTA, Description, Title } from "@/ui";
import clsx from "classnames";
import classes from "./styles.module.scss";

export default function HeaderSideImage({ className, containerClassName, img, back, title, description, cta, bgColor, textColor, button, reverse, align }) {
  const alignClass = align === "right" ? "text-end" : "text-start";
  const contentCol = (
    <Col xs={12} md={6} className={clsx(classes.header__content, "py-5")}>
      <BackLink back={back} />
      <Title className={clsx(reverse ? "ms-4" : "me-4", textColor, "mb-0", alignClass)} title={title} tag="h1" />
      <div className={reverse ? "ms-4" : "me-4"}>
        <Description className={clsx("mt-4", textColor)} description={description} />
        {cta && <CTA className="mt-4" label={cta.label} href={cta.href} variant={cta.variant} />}
        {button?.map((btn, k) => (
          <CTA
            key={k}
            label={btn.label}
            href={btn.href}
            className="mt-4"
            variant={btn.variant}
            target={btn.open_in_new_tab ? "_blank" : undefined}
          />
        ))}
      </div>
    </Col>
  );

  const imageCol = (
    <Col xs={12} md={6} className="px-0 overflow-hidden">
      <img src={img} resize={false} alt="Header image" />
    </Col>
  );

  return (
    <div className={clsx(className, bgColor, classes.header)}>
      <Container fluid className={containerClassName}>
        <Row>
          {reverse ? imageCol : contentCol}
          {reverse ? contentCol : imageCol}
        </Row>
      </Container>
    </div>
  );
}

HeaderSideImage.defaultProps = {
  containerClassName: "mw-xxl",
};
